import apiClient from "../api/axios";
import {
  GetNotificationsResponse,
  NotificationItem,
} from "../models/Notification";

const NOTIFICATION_BASE_URL = "/v1/notifications";

const getPendingNotifications = async (): Promise<NotificationItem[]> => {
  try {
    const response = await apiClient.get<GetNotificationsResponse>(
      `${NOTIFICATION_BASE_URL}/pending`,
    );

    return response.data.results.notifications;
  } catch (error) {
    throw error;
  }
};

const respondToNotification = async (
  notificationId: string,
  actionKey: string,
): Promise<boolean> => {
  try {
    const payload = {
      action: actionKey,
    };

    // ยิง POST Request
    await apiClient.post(
      `${NOTIFICATION_BASE_URL}/${notificationId}/action`,
      payload,
    );

    return true;
  } catch (error) {
    throw error;
  }
};

const NotificationService = {
  getPendingNotifications,
  respondToNotification,
};

export default NotificationService;
